import { Fragment } from "react";
import { NavLink } from "react-router-dom";
import "./Insurance.css";
import PhoneIcon from "@mui/icons-material/Phone";
import insurance from "../../assets/images/services/insurance/insurance.png";
import trust from "../../assets/images/services/insurance/trust.png";
import efficiency from "../../assets/images/services/insurance/efficiency.png";
import collaboration from "../../assets/images/services/insurance/collaboration.png";

const Insurance = () => {
  return (
    <Fragment>
      <section className="insurance-style">
        <div className="insurance-banner-content">
          <div className="container">
            <div
              className="subtitle-gradient"
              data-aos="fade-down"
              data-aos-delay="200"
              data-aos-duration="1200"
            >
              Insurance
            </div>
            <h1
              data-aos="fade-down"
              data-aos-delay="400"
              data-aos-duration="1200"
            >
              Blockchain development In Insurance
            </h1>
            <p
              data-aos="fade-down"
              data-aos-delay="600"
              data-aos-duration="1200"
            >
              Blockchain solutions help insurance companies increase the
              efficiency and transparency of underwriting, reinsurance, and
              claim management processes, prevent fraud, increase customer
              trust, and access new markets.
            </p>
            <div
              className="consultation-btn"
              data-aos="fade-down"
              data-aos-delay="800"
              data-aos-duration="1200"
            >
              <NavLink to="/contact" target="-black">
                <span>
                  Request A Consultation <PhoneIcon />
                </span>
              </NavLink>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="insurance-content">
            <div className="row">
              <div className="col-lg-5 d-flex align-items-center justify-content-center">
                <div className="insurance-left-image">
                  <img
                    src={insurance}
                    alt="img-not-found"
                    data-aos="zoom-in-up"
                    data-aos-delay="200"
                    data-aos-duration="1200"
                  />
                </div>
              </div>
              <div className="col-lg-7">
                <h4
                  className="mb-4"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1200"
                >
                  Benefits of blockchain for insurance companies
                </h4>
                <p
                  className="mb-5"
                  data-aos="fade-up-left"
                  data-aos-delay="400"
                  data-aos-duration="1200"
                >
                  The core benefit of blockchain in the insurance industry is
                  that it builds trust between parties sharing information. In
                  simple words, Blockchain is a distributed ledger technology
                  that is used to record and store transactions in a secured
                  manner as an electronic list of records or blocks. These
                  blocks cannot be erased, which helps to ensure trust between
                  users involved in a transaction. Blockchain works by creating
                  an immutable shared database that is constantly updated in
                  real-time to reflect all changes made to each data block
                  within its network. Such a zero-trust architecture makes it
                  impossible for any single entity or user on the network to
                  modify previous records without being detected first. If they
                  try, they will be flagged by other users who can take action
                  against those attempting to fraudulently change the entries.
                  It also means there's no central authority controlling this
                  process - it's all peer-to-peer instead!
                </p>
              </div>
            </div>
          </div>

          <div className="insurance-benefitkey text-center">
            <div className="row">
              <div
                className="col-lg-4 col-md-4"
                data-aos="zoom-in-up"
                data-aos-delay="200"
                data-aos-duration="1200"
              >
                <div className="insurance-icon">
                  <img src={trust} alt="img-not-found" />
                </div>
                <h6>Trust</h6>
                <p>
                  Seamless filing and quick payouts build consumer trust.
                  Immutable ledgers protect consumer data, ensuring privacy
                  until needed for policy changes or new coverage.
                </p>
              </div>
              <div
                className="col-lg-4 col-md-4"
                data-aos="zoom-in-up"
                data-aos-delay="400"
                data-aos-duration="1200"
              >
                <div className="insurance-icon">
                  <img src={efficiency} alt="img-not-found" />
                </div>
                <h6>Efficiency</h6>
                <p>
                  Blockchain modernizes outdated claim systems with shared IT
                  infrastructure. It streamlines interactions among agents,
                  customers, and payers, eliminating silos and automating
                  processes.
                </p>
              </div>
              <div
                className="col-lg-4 col-md-4"
                data-aos="zoom-in-up"
                data-aos-delay="600"
                data-aos-duration="1200"
              >
                <div className="insurance-icon">
                  <img src={collaboration} alt="img-not-found" />
                </div>
                <h6>Collaboration</h6>
                <p>
                  During accidents or disasters, prompt customer care is
                  crucial. Blockchain's shared ledger facilitates instant,
                  accurate data sharing. Smart contracts automate transactions
                  based on predefined events, ensuring swift business responses.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="insurance-usecase">
          <div className="container">
            <div className="text-center">
              <h1
                data-aos="fade-down"
                data-aos-delay="300"
                data-aos-duration="1200"
              >
                Use Cases for Blockchain in Insurance
              </h1>
            </div>
            <div className="row">
              <div
                className="col-lg-3 col-md-6"
                data-aos="fade-left"
                data-aos-delay="200"
                data-aos-duration="1200"
              >
                <h6>Automated claims processing</h6>
                <p>
                  Smart contracts automate claim approvals and payments based on
                  predefined events, digitizing and streamlining processes once
                  handled manually.
                </p>
              </div>
              <div
                className="col-lg-3 col-md-6"
                data-aos="fade-left"
                data-aos-delay="400"
                data-aos-duration="1200"
              >
                <h6>Fraud detection</h6>
                <p>
                  Immutable records and verified identities enable insurers to
                  validate claim histories and reject fraudulent claims.
                  Community governance enhances accountability through shared
                  records.
                </p>
              </div>
              <div
                className="col-lg-3 col-md-6"
                data-aos="fade-left"
                data-aos-delay="600"
                data-aos-duration="1200"
              >
                <h6>Micropayments</h6>
                <p>
                  Consortium integration enables detailed data sharing for
                  innovative products like micro-policies, instantly
                  compensating, for instance, a farmer based on weather events.
                </p>
              </div>
              <div
                className="col-lg-3 col-md-6"
                data-aos="fade-left"
                data-aos-delay="800"
                data-aos-duration="1200"
              >
                <h6>Compliance & governance</h6>
                <p>
                  Blockchain securely stores digital documents and integrates
                  policy details for seamless regulatory compliance and disaster
                  recovery at no extra cost.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default Insurance;
